import type { FormFields } from "@/forms/pokemon/searchSingleProduct";

/**
 * TODO:
 *
 * - レギュレーション
 */
export const buildPokemonSingleProductQuery = (fields: FormFields) => {
  const {
    keyword,
    kindPokemon,
    kindItem,
    kindSupporter,
    kindStadium,
    kindPokemonTool,
    kindBasicEnergy,
    kindSpecialEnergy,
    packId,
    rarityId,
    sellingPriceGte,
    sellingPriceLte,
    regulationName,
  } = fields;

  const mustQuery: object[] = [
    {
      "range": {
        "publish_from": {
          "lte": "now"
        }
      }
    }
  ];

  if (keyword) {
    const keywordChunks = keyword.split(/[,、\s　]+/).filter(Boolean)
    for (const chunk of keywordChunks) {
      const _query = {
        bool: {
          should: [
            {
              multi_match: {
                query: chunk,
                fields: [
                  "product_name^50",
                  "product_name_kana^50",
                  "pm_card.card_name^50",
                  "pm_card.card_name_kana^50"
                ],
                type: "phrase"
              }
            },
            {
              match_phrase_prefix: {
                product_name: {
                  query: chunk,
                  slop: 2
                }
              }
            },
            {
              match_phrase_prefix: {
                "pm_card.card_name": {
                  query: chunk,
                  slop: 2
                }
              }
            },
            {
              match_phrase_prefix: {
                "pm_card.card_name_kana": {
                  query: chunk,
                  slop: 2
                }
              }
            },
            {
              nested: {
                path: "pm_card.moves",
                query: {
                  match_phrase_prefix: {
                    "pm_card.moves.move_name": {
                      query: chunk,
                      boost: 10,
                    },
                  },
                },
              },
            },
            {
              term: {
                "pm_card.pm_card_pokemon_types": chunk,
              },
            },
            {
              multi_match: {
                query: chunk,
                fields: [
                  "pm_card.rarity.rarity_id^50",
                  // "pm_card.rarity.rarity_name^50" // FIXME: rarity_nameは現在indexされていない
                ],
                type: "phrase"
              }
            },
          ],
        },
      };
      mustQuery.push(_query);

    }
  }

  const kindQueryTarget: object[] = []

  // カード種別
  const targetClassifications = [];
  if (kindPokemon) {
    targetClassifications.push("pokemon");
  }
  if (targetClassifications.length) {
    kindQueryTarget.push({
      terms: {
        "pm_card.pm_card_classification": targetClassifications,
      },
    });
  }

  // トレーナー種別
  const trainerKinds = [];
  if (kindItem) {
    trainerKinds.push("item");
  }
  if (kindSupporter) {
    trainerKinds.push("supporter");
  }
  if (kindStadium) {
    trainerKinds.push("stadium");
  }
  if (kindPokemonTool) {
    trainerKinds.push("pokemon_tool");
  }
  if (trainerKinds.length) {
    kindQueryTarget.push({
      terms: {
        "pm_card.pm_card_trainer_kind": trainerKinds,
      },
    });
  }

  // エネルギー種別
  const energyKinds = []
  if (kindBasicEnergy) {
    energyKinds.push('basic')
  }
  if (kindSpecialEnergy) {
    energyKinds.push('special')
  }
  if (energyKinds.length) {
    kindQueryTarget.push({
      terms: {
        "pm_card.pm_card_energy_kind": energyKinds
      }
    })
  }

  if (kindQueryTarget.length) {
    mustQuery.push({
      bool: {
        should: kindQueryTarget
      }
    })
  }

  // 収録検索
  if (packId) {
    mustQuery.push({
      term: {
        "pm_card.pack.pack_id": packId,
      },
    });
  }

  // レアリティ検索
  if (rarityId) {
    mustQuery.push({
      term: {
        "pm_card.rarity.rarity_id": rarityId,
      },
    });
  }

  // レギュレーション検索
  if (regulationName) {
    mustQuery.push({
      term: {
        "pm_card.regulations": regulationName
      }
    })
  }

  // 価格検索
  if (typeof sellingPriceGte === 'number' && typeof sellingPriceLte === 'number') {
    if (sellingPriceGte > sellingPriceLte) {
      // 不整合
      mustQuery.push({
        term: {
          "non_existing_field": true
        }
      })
    }
  }

  if (typeof sellingPriceGte === 'number') {
    mustQuery.push({
      range: {
        "rank_s_inventory.selling_price": {
          gte: sellingPriceGte,
        },
      },
    });
  }

  if (typeof sellingPriceLte === 'number') {
    mustQuery.push({
      range: {
        "rank_c_inventory.selling_price": {
          lte: sellingPriceLte,
        },
      },
    });
  }

  return {
    bool: {
      must: mustQuery,
      should: [
        {
          "range": {
            "publish_to": {
              "gt": "now"
            }
          }
        },
        {
          "bool": {
            "must_not": {
              "exists": {
                "field": "publish_to"
              }
            }
          }
        }
      ],
      minimum_should_match: 1
    },
  };
};
